import React from "react";
import PanelLayout from "../components/PanelLayout";
import "./styles/PanelMarketStore.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../redux/actions/marketstoreActions";
import MiniLoader from "../components/MiniLoader";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";
import { Translate, I18n } from "react-redux-i18n";
import { convertToWebp } from "../utils/imageUtils";
import { FaPencilAlt, FaExternalLinkAlt, FaTrash } from "react-icons/fa";
import { hasActiveSubscriptionPlan } from "../assets/subscriptionUtils";
import * as actions_suscription from "../redux/actions/suscriptionPlanActions";

class PanelMarketStore extends React.Component {
  state = {
    cover: "",
    logo: "",
  };

  componentDidMount() {
    this.fetchMarketStoreData();
    this.fetchSuscriptionPlan();
  }

  fetchSuscriptionPlan = async () => {
    try {
      await this.props.LoadSuscriptionPlan(this.props.user_id, this.props.token);
    } catch (error) {
      console.log(error);
    }
  };

  fetchMarketStoreData = async () => {
    try {
      await this.props
        .LoadMyMarketStore(this.props.token, {
          id: this.props.user_id,
          lang: I18n.t("locale"),
        })
        .then(() => {
          if (this.props.error) {
            alert(this.props.error);
          } else if (this.props.marketstore !== null) {
            this.setState({
              cover: this.props.marketstore.BackGroundPicturePage,
              logo: this.props.marketstore.Logo,
            });
          }
        });
    } catch (error) {
      console.log(error);
      alertify.warning(I18n.t(this.props.errorUpdate));
    }
  };

  onClickCreateStore = async () => {
    try {
      await this.props
        .CreateMyMarketStore(this.props.token, {
          id: this.props.user_id,
        })
        .then(() => {
          if (this.props.errorUpdate) {
            alertify.warning(I18n.t(this.props.errorUpdate));
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  onChangeCover = async (event) => {
    event.preventDefault();

    let reader = new FileReader();
    let file = event.target.files[0];
    const webpFile = await convertToWebp(file);

    reader.onloadend = () => {
      this.setState({
        cover: reader.result,
      });
    };
    reader.readAsDataURL(webpFile);

    let params = new FormData();
    params.append("image", webpFile);
    params.append("id", this.props.user_id);

    await this.props.UploadCover(this.props.token, params).then(() => {
      if (this.props.errorUpdate) {
        alertify.warning(I18n.t(this.props.errorUpdate));
      } else {
        alertify.success(I18n.t("image_loaded"));
      }
    });
  };

  onChangeLogo = async (event) => {
    event.preventDefault();

    let reader = new FileReader();
    let file = event.target.files[0];
    const webpFile = await convertToWebp(file);

    reader.onloadend = () => {
      this.setState({
        logo: reader.result,
      });
    };
    reader.readAsDataURL(webpFile);

    let params = new FormData();
    params.append("image", webpFile);
    params.append("id", this.props.user_id);

    await this.props.UploadLogo(this.props.token, params).then(() => {
      if (this.props.errorUpdate) {
        alertify.warning(I18n.t(this.props.errorUpdate));
      } else {
        alertify.success(I18n.t("image_loaded"));
      }
    });
  };

  onClickRemove = async () => {
    await this.props
      .RemoveStore(this.props.token, {
        store_id: this.props.marketstore.Id,
        id: this.props.user_id,
      })
      .then(() => {
        if (this.props.errorUpdate) {
          alertify.warning(I18n.t(this.props.errorUpdate));
        } else {
          alertify.success(I18n.t("deleted"));
        }
      });
  };

  render() {
    const { marketstore, loading, suscription, loadingSuscription } = this.props;
    const hasActivePlan = hasActiveSubscriptionPlan(suscription);
    const coverStyle = this.state.cover
      ? { backgroundImage: `url(${this.state.cover})` }
      : undefined;

    return (
      <PanelLayout>
        <div className="panel-marketstore-page">
          <header className="panel-marketstore-page__header">
            <h1 className="panel-marketstore-page__title">
              <Translate value="marketstore_title" />
            </h1>
            {marketstore && (
              <button
                type="button"
                className="panel-marketstore-page__delete"
                onClick={this.onClickRemove}
              >
                <FaTrash />
                <Translate value="marketstore_delete" />
              </button>
            )}
          </header>

          {loading ? (
            <div className="panel-marketstore-page__loading">
              <MiniLoader />
            </div>
          ) : marketstore === null ? (
            <div className="panel-marketstore-empty">
              <p className="panel-marketstore-empty__text">
                <Translate value="marketstore_not_list" />
              </p>
              {loadingSuscription ? (
                <div className="panel-marketstore-page__loading">
                  <MiniLoader />
                </div>
              ) : hasActivePlan ? (
                <button
                  type="button"
                  className="panel-marketstore-page__activate-btn"
                  onClick={this.onClickCreateStore}
                >
                  <Translate value="marketstore_activate" />
                </button>
              ) : (
                <React.Fragment>
                  <p className="panel-marketstore-empty__hint">
                    <Translate value="marketstore_requires_subscription" />
                  </p>
                  <Link
                    to="/mysuscription"
                    className="panel-marketstore-page__activate-btn panel-marketstore-page__activate-btn--link"
                  >
                    <Translate value="suscription_mine" />
                  </Link>
                </React.Fragment>
              )}
            </div>
          ) : (
            <div className="panel-marketstore-card">
              <div className="panel-marketstore-hero" style={coverStyle}>
                <div className="panel-marketstore-hero__overlay" />
                <div className="panel-marketstore-hero__logo-wrap">
                  <img
                    className="panel-marketstore-hero__logo"
                    src={this.state.logo}
                    alt={marketstore.Name || "Store"}
                  />
                </div>
                <div className="panel-marketstore-hero__content">
                  <h2
                    className="panel-marketstore-hero__name"
                    style={
                      marketstore.TextColor
                        ? { color: marketstore.TextColor }
                        : { color: "#ffffff" }
                    }
                  >
                    {marketstore.Name}
                  </h2>
                  {marketstore.Description && (
                    <p
                      className="panel-marketstore-hero__description"
                      style={
                        marketstore.BackGroundColor
                          ? { color: marketstore.BackGroundColor }
                          : { color: "rgba(255,255,255,0.92)" }
                      }
                    >
                      {marketstore.Description}
                    </p>
                  )}
                </div>
              </div>

              <div className="panel-marketstore-uploads">
                <div className="panel-marketstore-upload">
                  <input
                    accept="image/*"
                    id="file_input_background"
                    type="file"
                    name="open_img"
                    className="panel-marketstore-upload__input"
                    onChange={this.onChangeCover}
                  />
                  <label
                    htmlFor="file_input_background"
                    className="panel-marketstore-upload__btn"
                  >
                    <Translate value="marketstore_change_background" />
                  </label>
                </div>
                <div className="panel-marketstore-upload">
                  <input
                    accept="image/*"
                    id="file-input_logo"
                    type="file"
                    name="open_img"
                    className="panel-marketstore-upload__input"
                    onChange={this.onChangeLogo}
                  />
                  <label
                    htmlFor="file-input_logo"
                    className="panel-marketstore-upload__btn"
                  >
                    <Translate value="marketstore_change_logo" />
                  </label>
                </div>
              </div>

              {this.props.loadingUpdate && (
                <div className="panel-marketstore-page__loading">
                  <MiniLoader />
                </div>
              )}

              <div className="panel-marketstore-actions">
                <Link
                  to="/panel/marketstore/edit"
                  className="panel-marketstore-action panel-marketstore-action--edit"
                >
                  <FaPencilAlt />
                  <Translate value="marketstore_edit" />
                </Link>
                <Link
                  className="panel-marketstore-action panel-marketstore-action--view"
                  to={`/marketstore/show/${marketstore.Id}`}
                >
                  <FaExternalLinkAlt />
                  <Translate value="marketstore_see" />
                </Link>
              </div>
            </div>
          )}
        </div>
      </PanelLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,

    error: reducer.marketstore.error,
    loading: reducer.marketstore.loading,
    marketstore: reducer.marketstore.item,

    errorUpdate: reducer.marketstore.error_update,
    loadingUpdate: reducer.marketstore.loading_update,
    suscription: reducer.suscriptionPlan.item,
    loadingSuscription: reducer.suscriptionPlan.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMyMarketStore: (token, params) =>
    dispatch(actions.loadItemMe({ token, params })),
  LoadSuscriptionPlan: (user_id, token) =>
    dispatch(actions_suscription.loadItem({ user_id, token })),
  CreateMyMarketStore: (token, params) =>
    dispatch(actions.newItem({ token, params })),
  UploadCover: (token, params) =>
    dispatch(actions.uploadCover({ token, params })),
  UploadLogo: (token, params) =>
    dispatch(actions.uploadLogo({ token, params })),
  RemoveStore: (token, params) =>
    dispatch(actions.removeStore({ token, params })),
});

export default connect(mapStateToProps, mapDispatchToProps)(PanelMarketStore);
